import { Controller } from "@hotwired/stimulus";
import * as Sentry from "@sentry/browser";
import posthog from "posthog-js";

export default class LogoutController extends Controller {
  static override values = { url: String };
  declare readonly urlValue: string;

  logout(): void {
    try {
      posthog.reset();
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          message: "PostHog reset error during logout",
        },
      });
    }

    // Navigate to the logout URL.
    window.location.href = this.urlValue;
  }
}
